// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ViewOff: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 18" enableBackground="new 0 0 24 18" xmlSpace="preserve">
<g>
	<path d="M7.93,6.91c-0.3,0.59-0.48,1.26-0.48,1.97c0,2.46,2.06,4.45,4.6,4.45c0.68,0,1.32-0.14,1.9-0.39L13,11.98
		c-0.3,0.08-0.61,0.13-0.94,0.13c-1.87,0-3.38-1.45-3.38-3.22c0-0.36,0.06-0.71,0.18-1.04L7.93,6.91z"/>
	<path d="M12,14.4c-4.25,0-8.14-2.11-10.44-5.51c1.13-1.67,2.63-3.02,4.38-3.97L4.98,3.96C3,5.11,1.32,6.74,0.11,8.74L0.07,8.8
		L0,8.85l0.02,0.04L0,8.93l0.08,0.05L0.22,9.2c2.5,4.01,6.93,6.51,11.78,6.51c1.42,0,2.8-0.21,4.11-0.62l-1.06-1.06
		C14.07,14.27,13.05,14.4,12,14.4z"/>
	<path d="M16.3,10.62c0.23-0.53,0.36-1.12,0.36-1.74c0-2.46-2.06-4.45-4.6-4.45c-0.58,0-1.14,0.1-1.65,0.3l0.99,0.99
		c0.21-0.04,0.43-0.06,0.66-0.06c1.87,0,3.38,1.45,3.38,3.22c0,0.27-0.03,0.53-0.1,0.78L16.3,10.62z"/>
	<rect x="11.89" y="-2.53" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.8389 11.6066)" width="1.41" height="23.53"/>
	<path d="M24,8.85L23.92,8.8l-0.14-0.23C21.28,4.56,16.86,2.06,12,2.06c-1.29,0-2.55,0.18-3.75,0.51l1.08,1.08
		C10.2,3.47,11.09,3.37,12,3.37c4.25,0,8.14,2.11,10.44,5.51c-1.06,1.57-2.46,2.86-4.07,3.8l0.95,0.95
		c1.85-1.14,3.42-2.71,4.57-4.61l0.04-0.06L24,8.93l-0.02-0.04L24,8.85z"/>
</g>
</svg>;
};

export default React.memo(ViewOff);
